import { FC } from "react";
import { StepOption } from "../../../types/wizard";

interface ColorInputProps {
  color?: StepOption | null;
  border: string;
  toggleEdit: () => void;
  isLoading?: boolean;
}

const ColorInputSkeleton: FC<{ border: string }> = ({ border }) => {
  return (
    <>
      <div className="animate-pulse h-6 bg-gray-300 rounded w-28 mb-2.5"></div>
      <div className={`${border} p-2.5 relative rounded bg-white animate-pulse`}>
        <div className="flex flex-row items-center gap-2">
          <div className="w-8 h-8 bg-gray-300 rounded"></div>
          <div className="h-6 bg-gray-300 rounded w-24 flex-1"></div>
          <div className="h-4 bg-gray-300 rounded w-8"></div>
        </div>
      </div>
    </>
  );
};

const ColorInput: FC<ColorInputProps> = ({ color, border, toggleEdit, isLoading }) => {
  const handleClick = () => {
    if (toggleEdit) {
      toggleEdit();
    }
  };

  const borderColor: boolean = !!(color?.htmlColor && color.htmlColor === "#FFFFFF");

  if (isLoading) {
    return <ColorInputSkeleton border={border} />;
  }

  return (
    <>
      <div
        className={`${border} p-2.5 cursor-pointer relative rounded bg-white`}
        onClick={handleClick}>
        {color && color?.htmlColor ? (
          <div className="flex flex-row items-center gap-2">
            <div
              className="w-8 h-8 rounded"
              style={{
                backgroundColor: color.htmlColor || "",
                border: `${borderColor ? '1px solid #a7acaf' : 'none'}`,
              }}></div>
            <span>{color.name}</span>
            <span
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm underline"
              onClick={handleClick}>
              Edit
            </span>
          </div>
        ) : (
          <>
            <div className="flex flex-row justify-between items-center text-slate-400">
              <span style={{ display: "flex" }}>Select a Colour</span>
            </div>
            <span
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm underline"
              onClick={handleClick}>
              Edit
            </span>
          </>
        )}
      </div>
    </>
  );
};

export default ColorInput;
